import React from 'react';
import StudioState from '@home/pages/studio/components/StudioState';
import CommonPDFPreviewDownload from '@intelligence/components/PDFPreviewDownload';
import useSearchParams from '@gp/hooks/useSearchParams';
import usePDFPreviewDownload from '@intelligence/pages/PDFPreviewDownload/_hooks/usePDFPreviewDownload';
import { pageReportTypeConfig } from '@intelligence/pages/InsightsReport/_config';

import type { IBaseProps } from '@intelligence/types/common';

interface IPDFPreviewDownloadProps extends IBaseProps {}

const PDFPreviewDownload: React.FC<IPDFPreviewDownloadProps> = (props) => {
  const {} = props;

  const { referer } = useSearchParams();

  const {
    resourceName,
    resourcePath,
    resourceOriginalPath,
    downloadable,
    downloadLogKey,
    watermarkEnable,
    fetchPDFUrl,
    resourceId,
    systemId,
    studioId,
    studioAble,
    studioAbleLoading,
    iicLoading,
    detailLoading,
    lang,
    fileExtName,
  } = usePDFPreviewDownload();

  if (detailLoading) {
    return null;
  }

  return (
    <>
      {!studioAble && systemId === pageReportTypeConfig.studioReport.systemIdCur && !studioAbleLoading ? (
        <StudioState isNoPermission={true} />
      ) : (
        <CommonPDFPreviewDownload
          referer={referer}
          fileName={resourceName}
          filePath={resourcePath}
          originalFilePath={resourceOriginalPath}
          downloadable={downloadable}
          downloadLogKey={downloadLogKey}
          watermarkEnable={watermarkEnable}
          iicLoading={iicLoading}
          fetchPDFUrl={fetchPDFUrl}
          resourceId={resourceId}
          systemId={systemId}
          studioId={studioId}
          lang={lang}
          fileExtName={fileExtName}
        />
      )}
    </>
  );
};

export default PDFPreviewDownload;
